<button [ngClass]="buttonClass" [class.mod-secondary]="secondary" [class.mod-large]="large" [type]="type">
    <cp-icon *ngIf="icon; else buttonLabel" class="button-icon" [icon]="icon" [size]="30" [colorClass]="colorClass">
    </cp-icon>
</button>

<ng-template #buttonLabel>
  {{label | translate}}
</ng-template>
